import styles from './developer-unknown-logo.module.scss';
import env from '@y2/environments';
import Image from 'next/image';
import cn from 'classnames';
import React from 'react';

type Props = {
  className?: string;
  title: string;
};

export const DeveloperUnknownLogo = ({ className, title }: Props) => {
  return (
    <div className={cn(styles.developerUnknownLogoBox, className)}>
      <Image
        src={`${env.assets.basePath}/yad1/logo.png`}
        width={70}
        height={36}
        alt={title}
      />
      <span className={styles.title}>{title}</span>
    </div>
  );
};
